import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { supabase } from './services/supabase'
import { useAuthStore } from './hooks/useAuth'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Works from './pages/Works'
import WorkEditor from './pages/WorkEditor'
import Journals from './pages/Journals'
import Submissions from './pages/Submissions'
import Login from './pages/Login'
import Register from './pages/Register'
import Profile from './pages/Profile'

function App() {
  const { setUser, clearUser } = useAuthStore()

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser({
          id: session.user.id,
          email: session.user.email!,
          firstName: session.user.user_metadata?.first_name,
          lastName: session.user.user_metadata?.last_name,
          createdAt: session.user.created_at,
          updatedAt: session.user.updated_at || session.user.created_at,
        })
      }
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser({
          id: session.user.id,
          email: session.user.email!,
          firstName: session.user.user_metadata?.first_name,
          lastName: session.user.user_metadata?.last_name,
          createdAt: session.user.created_at,
          updatedAt: session.user.updated_at || session.user.created_at,
        })
      } else {
        clearUser()
      }
    })

    return () => subscription.unsubscribe()
  }, [setUser, clearUser])

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="works" element={<Works />} />
        <Route path="works/new" element={<WorkEditor />} />
        <Route path="works/:id" element={<WorkEditor />} />
        <Route path="journals" element={<Journals />} />
        <Route path="submissions" element={<Submissions />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  )
}

export default App